import Swiper from 'swiper/bundle';

const getSwiperA11yMessages = () => {
	const locale = window.Shopify?.locale || document.documentElement.lang || 'uk';
	const isUk = locale === 'uk';

	return {
		enabled: true,
		slideLabelMessage: '',
		paginationBulletMessage: isUk ? 'Перейти до слайду {{index}}' : 'Перейти к слайду {{index}}',
		nextSlideMessage: isUk ? 'Наступний слайд' : 'Следующий слайд',
		prevSlideMessage: isUk ? 'Попередній слайд' : 'Предыдущий слайд',
	};
};

export function manual() {
	let sliderEl = document.querySelector('.manual .swiper');
	
	if (sliderEl) {
		let slider = new Swiper(sliderEl, {
			// loop: true,
			speed: 500,
			allowTouchMove: false,
			touchReleaseOnEdges: true,
			slidesPerView: 1,
			direction: 'vertical',
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			
			pagination: {
				el: ".manual .controls-v__pagination",
				bulletClass: 'controls-v__bullet',
				bulletActiveClass: 'controls-v__bullet--active',
				clickable: true
			},
			navigation: {
				prevEl: ".manual .controls-v__button--prev",
				nextEl: ".manual .controls-v__button--next",
				disabledClass: 'controls-v__button--disabled'
			},
			a11y: getSwiperA11yMessages(),
		});
	}
}
